import finnishFlag from "../../Images/flags/Finland.svg";
import Candle from "../Candle";

export default function Independence() {
  return (
    <div>
      <h1
        style={{
          background: "rgba(255, 255, 255, 0.5)",
          textAlign: "center",
          width: "fit-content",
        }}
      >
        Toivottaa Hyvää Itsenäisyyspäivää!{" "}
        <img src={finnishFlag} alt="Flag of Finland" width={60} />
      </h1>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      ></div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1%",
        }}
      >
        <Candle />
        <Candle />
      </div>
    </div>
  );
}
